import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconBuildingBlock20(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={20}
            className={customClassName}
            name="IconBuildingBlock20"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M7.5 4.5h-2v1h2zM4 4.5v1h-.5A2.5 2.5 0 0 0 1 8v6.5A2.5 2.5 0 0 0 3.5 17h13a2.5 2.5 0 0 0 2.5-2.5V8a2.5 2.5 0 0 0-2.5-2.5H16v-1A1.5 1.5 0 0 0 14.5 3h-2A1.5 1.5 0 0 0 11 4.5v1H9v-1A1.5 1.5 0 0 0 7.5 3h-2A1.5 1.5 0 0 0 4 4.5m8.5 1h2v-1h-2zM11 7H3.5a1 1 0 0 0-1 1v6.5a1 1 0 0 0 1 1h13a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconBuildingBlock20);
